import { STATIC_DICTIONARY_MAP } from '@/constants/static-dictionary'
import { request } from '@/network/axios'
import { get, post } from '@/network/client'

import { BaseRes, BaseRes2, DictionaryItem } from './type'

export interface KefuInfoPayload {
  phone?: string
  wechat?: string
  work_time?: string
  workTime?: string
  qrcode_url?: string
  qr_code?: string
  qrCodeUrl?: string
}

/**
 * platform 暂无 dictionary 模块：返回静态字典（兼容旧调用方）
 * 旧接口：GET /dictionary/find_dict_enable
 */
export const getDictionaryListApi = async (): Promise<BaseRes2<DictionaryItem>> => {
  const list: DictionaryItem[] = Object.entries(STATIC_DICTIONARY_MAP).map(([code, entries], index) => ({
    id: index + 1,
    name: code,
    code,
    sort: index,
    status: true,
    entries: entries.map((item, entryIndex) => ({
      id: entryIndex + 1,
      name: item.label,
      code: item.value,
      sort: entryIndex,
      status: true,
    })),
  }))
  return { code: 0, message: 'static', list }
}

/** 发送短信验证码 → platform apigate /auth/sms/send（cacheKey 即 scene） */
export const getSmsCodeApi = (data: { phone: string; cacheKey?: string }) =>
  post<any>('auth/sms/send', { phone: data.phone, scene: data.cacheKey || 'login' })

/** 更换手机号 → POST auth/change-phone（需登录态，验证码发往新手机号） */
export const changePhoneApi = (data: { phone: string; sms_code: string }): Promise<any> =>
  request.post('auth/change-phone', { newPhone: data.phone, smsCode: data.sms_code })
export const findCountCardApi = () => get<any>('webofficial/cart/count')
export const findCountOrderApi = () => get<any>('webofficial/orders/count')
export const getKefuInfoApi = () => get<BaseRes<KefuInfoPayload>>('webofficial/support/kefu')

// ─── Navigation Menu Sync ────────────────────────────────────────────────────

export interface NavMenuConfig {
  badge?: string
  comingSoon?: boolean
  matchPattern?: string
  icon?: string
  openInNewTab?: boolean
}

export interface NavMenuItem {
  id: number
  title: string
  title_i18n?: Record<string, string>
  path: string
  icon?: string
  sort: number
  type: 'CATALOG' | 'MENU'
  parent_id?: number
  config?: NavMenuConfig
  children?: NavMenuItem[]
}

export const getNavigationMenusApi = () => get<{ code: number; data: NavMenuItem[] }>('webofficial/menus/navigation')
